import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmailMarketingSpeaker = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 197 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M22.8872 4H193.649C195.305 4 196.649 5.34315 196.649 7V25C196.649 26.6569 195.305 28 193.649 28H22.8872V4Z",
			fill: "#0C0F33"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M186.965 20.1313H186.897C186.773 20.7093 186.433 21.1909 185.877 21.5763C185.333 21.9503 184.608 22.1373 183.701 22.1373C182.999 22.1373 182.347 22.0069 181.746 21.7463C181.146 21.4743 180.624 21.0833 180.182 20.5733C179.752 20.0519 179.412 19.4116 179.162 18.6523C178.924 17.8816 178.805 16.9976 178.805 16.0003C178.805 15.0143 178.93 14.1416 179.179 13.3823C179.429 12.6116 179.78 11.9656 180.233 11.4443C180.687 10.9229 181.231 10.5319 181.865 10.2713C182.5 9.99928 183.208 9.86328 183.99 9.86328C185.056 9.86328 185.957 10.1013 186.693 10.5773C187.43 11.0419 188.002 11.6936 188.41 12.5323L186.846 13.4503C186.62 12.8949 186.268 12.4473 185.792 12.1073C185.316 11.7559 184.716 11.5803 183.99 11.5803C183.05 11.5803 182.29 11.8806 181.712 12.4813C181.146 13.0819 180.862 13.9319 180.862 15.0313V16.9693C180.862 18.0686 181.146 18.9186 181.712 19.5193C182.29 20.1199 183.05 20.4203 183.99 20.4203C184.364 20.4203 184.721 20.3749 185.061 20.2843C185.401 20.1823 185.696 20.0406 185.945 19.8593C186.206 19.6666 186.41 19.4343 186.557 19.1623C186.716 18.8789 186.795 18.5503 186.795 18.1763V17.2583H184.347V15.6093H188.648V21.9333H186.965V20.1313Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M170.393 15.3714L169.084 12.8554H169.033V21.9334H167.197V10.0674H169.339L173.215 16.6294L174.524 19.1454H174.575V10.0674H176.411V21.9334H174.269L170.393 15.3714Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M159.615 21.9334V20.3694H161.229V11.6314H159.615V10.0674H164.782V11.6314H163.15V20.3694H164.782V21.9334H159.615Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M154.816 11.7674V21.9334H152.895V11.7674H149.359V10.0674H158.352V11.7674H154.816Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M140.335 21.9334V10.0674H147.934V11.7674H142.256V15.0654H147.407V16.7654H142.256V20.2334H147.934V21.9334H140.335Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M132.666 16.3914L131.034 18.2614V21.9334H129.113V10.0674H131.034V16.0854H131.102L132.802 13.9264L135.998 10.0674H138.242L134.009 15.0654L138.582 21.9334H136.27L132.666 16.3914Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119.894 21.9334H117.973V10.0674H123.09C124.155 10.0674 124.994 10.3904 125.606 11.0364C126.218 11.671 126.524 12.538 126.524 13.6374C126.524 14.4874 126.326 15.1957 125.929 15.7624C125.544 16.3177 124.971 16.7087 124.212 16.9354L126.779 21.9334H124.637L122.257 17.1394H119.894V21.9334ZM122.954 15.5244C123.441 15.5244 123.821 15.3997 124.093 15.1504C124.365 14.8897 124.501 14.5214 124.501 14.0454V13.2294C124.501 12.7534 124.365 12.3907 124.093 12.1414C123.821 11.8807 123.441 11.7504 122.954 11.7504H119.894V15.5244H122.954Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.129 21.9334L113.058 18.7204H108.621L107.584 21.9334H105.629L109.675 10.0674H112.089L116.135 21.9334H114.129ZM110.882 11.8354H110.797L109.08 17.0714H112.582L110.882 11.8354Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.95 12.8554H101.865L100.93 14.7764L98.3286 19.5194L95.7276 14.7764L94.7926 12.8554H94.7076V21.9334H92.8716V10.0674H95.1496L98.3286 16.1024H98.4306L101.61 10.0674H103.786V21.9334H101.95V12.8554Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.1382 21.9334V10.0674H82.0592V20.2334H86.8872V21.9334H80.1382Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.5559 21.9334V20.3694H74.1709V11.6314H72.5559V10.0674H77.7239V11.6314H76.0919V20.3694H77.7239V21.9334H72.5559Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.2222 21.9334L68.1512 18.7204H63.7142L62.6772 21.9334H60.7222L64.7682 10.0674H67.1822L71.2282 21.9334H69.2222ZM65.9752 11.8354H65.8902L64.1732 17.0714H67.6752L65.9752 11.8354Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.0424 12.8554H56.9574L56.0224 14.7764L53.4214 19.5194L50.8204 14.7764L49.8854 12.8554H49.8004V21.9334H47.9644V10.0674H50.2424L53.4214 16.1024H53.5234L56.7024 10.0674H58.8784V21.9334H57.0424V12.8554Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.8872 21.9334V10.0674H45.4862V11.7674H39.8082V15.0654H44.9592V16.7654H39.8082V20.2334H45.4862V21.9334H37.8872Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			rx: 16,
			fill: "#FE5800"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.88889 13.7447C8.39806 13.7447 8 14.1488 8 14.647V17.3537C8 17.852 8.39806 18.256 8.88889 18.256C9.205 18.256 9.46944 18.0789 9.62694 17.8269L12.5989 18.7376C12.5058 19.0128 12.4444 19.3026 12.4444 19.6094C12.4444 21.1021 13.6406 22.3162 15.1111 22.3162C16.3469 22.3162 17.3794 21.4542 17.6806 20.2945L21.3333 21.4139V10.5868L9.62694 14.1739C9.46944 13.9218 9.205 13.7447 8.88889 13.7447ZM13.8692 19.1267L16.41 19.9052C16.2764 20.5094 15.7458 20.9628 15.1111 20.9628C14.3758 20.9628 13.7778 20.3557 13.7778 19.6094C13.7778 19.4388 13.8122 19.277 13.8692 19.1267ZM23.5556 9.68457H22.6667C22.4211 9.68457 22.2222 9.88645 22.2222 10.1357V21.865C22.2222 22.1143 22.4211 22.3162 22.6667 22.3162H23.5556C23.8011 22.3162 24 22.1143 24 21.865V10.1357C24 9.88645 23.8011 9.68457 23.5556 9.68457Z",
			fill: "white"
		})
	]
});
export default SvgEmailMarketingSpeaker;
